/* @flow */
const defaultProductTypeId = 'business_card';

export const getDefaultProductSettings = () => ({
  isLoading: true,
  start: 0,
  hasMore: false,
  productTypeId: defaultProductTypeId,
  productSize: 'ALL',
  productSort: 'updatedDesc',
  template: 'ALL',
  searchTerm: '',
  isDeleting: false,
  isDeleted: false,
  isAdding: false,
  isAdded: false,
  isDownloading: false,
  isDownloaded: false,
  total: 0,
  selectAll: false,
});

export const buildUpdateSettings = (state: {}, action: { newSettings: {} }) => ({ ...state, ...action.newSettings });

export const resetProductSettings = () => getDefaultProductSettings();
